/**
 * Initialize Flatpickr date pickers for Monday-only selection
 * with cross-validation between start and end date pairs
 */
document.addEventListener('DOMContentLoaded', function() {
    // Define date picker pairs: [startId, endId]
    var datePairs = [
        ['start_date', 'end_date'],
        ['aggregator_start_date', 'aggregator_end_date']
    ];

    datePairs.forEach(function(pair) {
        var startInput = document.getElementById(pair[0]);
        var endInput = document.getElementById(pair[1]);

        if (!startInput || !endInput) return;

        var startInstance = initDatePicker(startInput, function(selectedDates) {
            if (selectedDates.length > 0) {
                endInstance.set('minDate', selectedDates[0]);
            } else {
                endInstance.set('minDate', endInput.dataset.minDate || null);
            }
        });

        var endInstance = initDatePicker(endInput, function(selectedDates) {
            if (selectedDates.length > 0) {
                startInstance.set('maxDate', selectedDates[0]);
            } else {
                startInstance.set('maxDate', startInput.dataset.maxDate || null);
            }
        });

        // Set initial constraints if values are pre-populated
        if (startInput.value) {
            endInstance.set('minDate', startInput.value);
        }
        if (endInput.value) {
            startInstance.set('maxDate', endInput.value);
        }
    });

    // Initialize any remaining standalone date pickers not part of a pair
    var pairedIds = [];
    datePairs.forEach(function(pair) {
        pairedIds.push(pair[0], pair[1]);
    });

    var standaloneInputs = document.querySelectorAll('.flatpickr-date');
    standaloneInputs.forEach(function(input) {
        if (pairedIds.indexOf(input.id) === -1 && !input._flatpickr) {
            initDatePicker(input);
        }
    });

    /**
     * Initialize a single Flatpickr instance with Monday-only selection
     *
     * @param {HTMLElement} input The input element
     * @param {Function} onChange Optional callback when date changes
     * @return {Object} The Flatpickr instance
     */
    function initDatePicker(input, onChange) {
        var minDate = input.dataset.minDate || null;
        var maxDate = input.dataset.maxDate || null;

        return flatpickr(input, {
            dateFormat: 'Y-m-d',
            minDate: minDate,
            maxDate: maxDate,
            // Disable all days except Mondays
            disable: [
                function(date) {
                    return date.getDay() !== 1;
                }
            ],
            // Highlight Mondays
            onDayCreate: function(dObj, dStr, fp, dayElem) {
                if (dayElem.dateObj.getDay() === 1) {
                    dayElem.classList.add('flatpickr-monday');
                }
            },
            onChange: function(selectedDates) {
                if (typeof onChange === 'function') {
                    onChange(selectedDates);
                }
            },
            // Accessibility
            ariaDateFormat: 'F j, Y',
            // Start week on Monday
            locale: {
                firstDayOfWeek: 1
            },
            allowInput: false,
            clickOpens: true
        });
    }
});
